import {
	DBType,
	RestAPI,
	IVIPCapabilityEvent,
	VIPCapabilityEvent,
	IRestCollectionParams,
	IRestResult,
	IRestParams,
	IRestDeleteParams,
	IVIPCapabilityEventOptions,
	staticImplements,
	IEntityRest,
	VIPCapabilityEventFields
} from "@/loader";

export interface IVIPCapabilityEventRestGetParams extends IRestParams {
	options?: IVIPCapabilityEventOptions;
}

export interface IVIPCapabilityEventRestCollectionParams extends IRestCollectionParams, IVIPCapabilityEventRestGetParams  {
	orderby?: VIPCapabilityEventFields | VIPCapabilityEventFields[];
	fk_capability?: number;
	fk_event?: number;
}

@staticImplements<IEntityRest<IVIPCapabilityEvent, VIPCapabilityEvent>>()
export abstract class VIPCapabilityEventRest {
	public static readonly endpoint: string = "capabilities/{fk_capability}/events";

	public static getURL(data?: IVIPCapabilityEvent | VIPCapabilityEvent, singular: boolean = false): string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.namespace];
		if (data?.fk_capability) {
			url.push(VIPCapabilityEventRest.endpoint.replace("{fk_capability}", data.fk_capability.toString()));
			if (singular && data?.fk_event) {
				url.push(data.fk_event.toString());
			}
		}
		return url.join("/");
	}

	public static async list(fk_capability: number, params?: IVIPCapabilityEventRestCollectionParams): Promise<IRestResult<VIPCapabilityEvent>> {
		return await RestAPI.list<IVIPCapabilityEvent, VIPCapabilityEvent>(VIPCapabilityEventRest.getURL({ fk_capability }), DBType.capabilityEvents, params);
	}

	public static async get(data: IVIPCapabilityEvent | VIPCapabilityEvent, params?: IVIPCapabilityEventRestGetParams): Promise<IRestResult<VIPCapabilityEvent>> {
		return await RestAPI.get<IVIPCapabilityEvent, VIPCapabilityEvent>(VIPCapabilityEventRest.getURL(data, true), DBType.capabilityEvents, params);
	}

	public static async create(data: IVIPCapabilityEvent | VIPCapabilityEvent): Promise<IRestResult<VIPCapabilityEvent>> {
		return await RestAPI.post<IVIPCapabilityEvent, VIPCapabilityEvent>(VIPCapabilityEventRest.getURL(data), data, DBType.capabilityEvents);
	}

	public static async update(data: IVIPCapabilityEvent | VIPCapabilityEvent): Promise<IRestResult<VIPCapabilityEvent>> {
		return await RestAPI.post<IVIPCapabilityEvent, VIPCapabilityEvent>(VIPCapabilityEventRest.getURL(data, true), data, DBType.capabilityEvents);
	}

	public static async delete(data: IVIPCapabilityEvent | VIPCapabilityEvent, params?: IRestDeleteParams): Promise<IRestResult<VIPCapabilityEvent>> {
		return await RestAPI.delete<IVIPCapabilityEvent, VIPCapabilityEvent>(VIPCapabilityEventRest.getURL(data, true), DBType.capabilityEvents, params);
	}
}
